import {
  PlotStyle,
  BarChartConfig,
  getTitleFromConfig,
  barChartTransformQuery,
} from './common';
import * as Panels from '../../util/panels';
import React from 'react';
import * as Query from '../../util/queryts';
import {toRunsDataQuery, RunsDataQuery} from '../../containers/RunsDataLoader';
import {parseExpressions} from '../PanelExpressionOptions';
import {useSampleAndQueryToTable} from '../../components/Export';
export type {PlotStyle, BarChartConfig};

const PANEL_TYPE = 'Bar Chart';

// We don't want the panel infrastructure to do the query for us, since the query
// we make depends on internal state. So we disable the
// outer query, and do our own query inside the panel.
const transformQuerySkip = (
  query: Query.Query,
  config: BarChartConfig
): RunsDataQuery => {
  const result = toRunsDataQuery(query);
  result.disabled = true;
  return result;
};

const useTableData = (pageQuery: Query.Query, config: BarChartConfig): any => {
  const query = barChartTransformQuery(
    pageQuery,
    config,
    parseExpressions(config.expressions, undefined)
  );

  return useSampleAndQueryToTable(query, pageQuery, config);
};

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, BarChartConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  getTitleFromConfig,
  transformQuery: transformQuerySkip,
  useTableData,

  exportable: {
    image: true,
    csv: true,
    api: true,
  },

  configSpec: {
    chartTitle: {editor: 'string', displayName: 'Chart title'},
    xAxisMin: {editor: 'number', displayName: 'X min'},
    xAxisMax: {editor: 'number', displayName: 'X max'},
  },

  icon: 'panel-bar-chart',
};
